import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { KycDocumentsResponse } from './types/Kyc';

export type LinkKycDocumentPayload = (
  userId: 'me' | number,
  kycUuid: string,
  data: {
    documentUuid: string;
    documentType: string;
  },
) => Promise<{ data: KycDocumentsResponse }>;

export default (makeCall: MakeCall): LinkKycDocumentPayload => (
  userId,
  kycUuid,
  data,
) =>
  makeCall<KycDocumentsResponse>(
    'POST',
    `${APIV2_URL}/user/${userId}/kyc/${kycUuid}/documents`,
    {
      data,
    },
  );
